<script setup lang="ts">
import type { AgentsHeroBlock } from "~/layers/agents/types/Agents";

const { section } = useThemeColor("light");

defineProps<{ content: AgentsHeroBlock }>();
</script>

<template>
  <section ref="section" class="pt-32 pb-20 md:pt-40 bg-primary relative overflow-hidden">
    <Container class="relative z-10">
      <Heading class="md:leading-[100%] mb-0 pt-2 md:pt-1 text-white" as="h2" variant="3" text-transform="uppercase">
        <span
          class="text-[1.8rem] font-medium lg:text-68 xl:text-90 leading-tight md:leading-[100%] mb-10"
          v-html="content?.title"
        />
      </Heading>
      <Image
        class="w-full h-[13,875rem] sm:h-[25rem] my-6 rounded-md object-cover aspect-video"
        :strapi-img="content.cover"
        alt=""
      />
      <div class="relative grid lg:grid-cols-2 gap-5 text-opacity-60">
        <Line class="top-0 opacity-20" />
        <div class="mt-7">
          <Text as="h2" variant="12" text-transform="uppercase" class="text-white/60">
            {{ content?.subtitle }}
          </Text>
        </div>
        <div class="grid lg:grid-cols-4 mt-7">
          <div class="col-span-3 flex-col flex gap-5">
            <Text variant="16" class="text-white/70">
              <span v-html="content.description" />
            </Text>
          </div>
        </div>
      </div>
    </Container>
    <div
      class="size-[1200px] pointer-events-none absolute top-0 left-0 -translate-y-1/2 -translate-x-1/2 bg-radial-gradient rounded-full opacity-30 blur-[30px]"
    />
    <div
      class="size-[1200px] pointer-events-none absolute bottom-0 right-0 translate-y-1/2 translate-x-1/2 bg-radial-gradient rounded-full opacity-30 blur-[30px]"
    />
  </section>
</template>

<style scoped></style>
